export default interface AddressHistory {
	unitNumber?: string;
	buildingName?: string;
	streetNumber: string;
	streetName: string;
	locality: string;
	suburb: string; // town or locality
	state: string; // province
	postcode: string;
	country: string;
	fromDate?: string;
	toDate?: string;
}

export interface AddressHistoryUiModel extends AddressHistory {
	from?: Date;
	to?: Date;
}

export const createNewAddressHistory = (): AddressHistory => {
	return {
		unitNumber: '',
		buildingName: '',
		streetNumber: '',
		streetName: '',
		locality: '',
		suburb: '',
		state: '',
		country: '',
		postcode: '',
		fromDate: null,
		toDate: null
	};
};
